import { Dialog } from "primereact/dialog"

/**
 * Modal component.
 *
 * @component
 * @param {any} props - The component props.
 * @returns {JSX.Element} The Modal component.
 */
const Modal = ({
  visible,
  onHide,
  header,
  footer = "",
  children,
  className,
  resizable = false,
  draggable = false,
  position = "center",
  style = {},
  size = "normal",
  closable = true,
  breakpoints,
  ...props
}: $TSMigrationFixMe) => {
  return (
    <Dialog
      breakpoints={breakpoints}
      style={{
        ...style,
      }}
      className={`${className} ${
        position === "right" ? "p-dialog-right" : ""
      } g-modal-${size}`}
      header={header}
      visible={visible}
      footer={footer}
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onHide={typeof onHide === "function" ? onHide : () => {}}
      draggable={draggable}
      resizable={resizable}
      position={position}
      closable={closable}
      closeOnEscape={false}
      {...props}
    >
      {children}
    </Dialog>
  )
}

export default Modal
